export default "__VITE_ASSET__D6azpFM4__"